import { service } from '../../../service';
import { router } from '../../../router';
import moment, { min } from 'moment';

const user = JSON.parse(localStorage.getItem('user'));
const company = null;
const state = {
  loading: false,
  user,
  company,
  locations: [],
  status: {},
  users: [],
  location: null,
  error: false,
  pathItems: [],
  offsetY: 0,
  drawerLeft: true,
  drawerLeftWidth: 200,
  drawerRight: true,
};

const actions = {
  clearError({ commit }) {
    commit('setError', null);
    commit('setLoading', false);
  },
  toggleLeftDrawer({ commit }, val) {
    commit('toggleLeftDrawer', val);
  },
  toggleRightDrawer({ commit }, val) {
    commit('toggleRightDrawer', val);
  },
  login({ dispatch, commit }, { email, password }) {
    commit('setLoading', true);
    commit('setError', false);

    service.login(email, password).then(
      (result) => {
        commit('setLoading', false);
        commit('setUser', result.user);
        commit('setCompany', result.company);
        commit('setLocations', result.locations);
        commit('setLocation');
        router.push('/');
      },
      (error) => {
        commit('setLoading', false);
        commit('setError', true);
      }
    );
  },
  logout({ commit }) {
    service.logout();
    commit('logout');
    router.push('/login');
  },
  register({ dispatch, commit }, { user, company }) {
    commit('setLoading', true);

    service.register({ user, company }).then(
      (result) => {
        console.log('REGISTERED');
        console.log(result);
        commit('setLoading', false);
        commit('setUser', result.user);
        commit('setCompany', result.company);
        commit('setSettings', result.settings);
        commit('setLocations', result.locations);
        commit('setLocation');
        router.push('/');
        setTimeout(() => {
          // display success message after route change completes
          dispatch('alert/success', 'Registration successful', { root: true });
        });
      },
      (error) => {
        commit('setLoading', false);
        commit('setError', true);
      }
    );
  },

  async reload({ commit, rootState }) {
    commit('setLoading', true);
    commit('setError', false);

    console.log(rootState.account);

    return service.reload(rootState.account.company._id).then(
      (result) => {
        console.log(result);
        commit('setLoading', false);
        commit('setUser', result.user);
        commit('setCompany', result.company);
        commit('setLocations', result.locations);
        commit('setLocation');
        return;
      },
      (error) => {
        commit('setLoading', false);
        commit('setError', true);
      }
    );
  },

  async getUsers({ commit, rootState }) {
    return service
      .get(`/users/${rootState.account.company._id}`)
      .then((result) => {
        console.log(result.users);
        commit('setUsers', result.users);
        return;
      });
  },
  async createUser({ dispatch, commit, rootState }, user) {
    commit('setLoading', true);

    return service
      .post(`/users/${rootState.account.company._id}`, user)
      .then((result) => {
        commit('newUser', result.user);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },
  async updateUser({ dispatch, commit, rootState }, user) {
    commit('setLoading', true);

    return service
      .updateUser(
        user,
        rootState.account.company._id,
        rootState.account.user._id == user._id
      )
      .then((result) => {
        commit('updateUser', result.user);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },
  async deleteUser({ dispatch, commit, rootState }, user) {
    commit('setLoading', true);

    return service
      .delete(`/users/${rootState.account.company._id}/${user}`)
      .then((result) => {
        commit('deleteUser', result.id);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async createLocation({ dispatch, commit, rootState }, location) {
    commit('setLoading', true);

    return service
      .post(`/companies/${rootState.account.company._id}/locations`, location)
      .then((result) => {
        commit('newLocation', result.location);
        commit('setLocations', rootState.account.locations);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async updateLocation({ commit, rootState }, location) {
    commit('setLoading', true);

    return service
      .patch(
        `/companies/${rootState.account.company._id}/locations/${location._id}`,
        location
      )
      .then((result) => {
        commit('updateLocation', result.location);
        return;
      });
  },

  async deleteLocation({ dispatch, commit, rootState }, id) {
    commit('setLoading', true);

    return service
      .delete(`/companies/${rootState.account.company._id}/locations/${id}`)
      .then((result) => {
        commit('deleteLocation', result.id);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  getCompany({ commit, rootState }) {
    return service.get(`/companies/${rootState.account.company._id}`).then(
      (result) => {
        commit('setCompany', result.company);
        commit('setLocations', result.locations);
      },
      (error) => {
        router.push('/login');
      }
    );
  },

  setAdminCompany({ commit }, company) {
    commit('setAdminCompany', company);
  },

  getApiKey({ rootState }) {
    return service
      .get(`/companies/${rootState.account.company._id}/api_key`)
      .then((key) => {
        return key;
      });
  },
  changeLocation({ commit }, location) {
    commit('changeLocation', location);
  },

  addImage({ dispatch, commit, rootState }, image) {
    console.log(image);
    return service
      .post(`/companies/${rootState.account.company._id}/general/image`, image)
      .then((result) => {
        commit('setCompany', result.company);
        dispatch('alert/success', result.message, { root: true });
      });
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  toggleLeftDrawer(state, val) {
    state.drawerLeft = val;
  },
  setError(state, error) {
    state.error = error;
  },
  setUser(state, user) {
    state.user = user;
    localStorage.setItem('user', JSON.stringify(state.user));
    state.loading = false;
  },
  setLocation(state) {
    var defaultLocation = state.locations.find((location) => {
      return location._id == state.user.defaultLocation;
    });
    state.location = defaultLocation;
  },

  setCompany(state, company) {
    state.company = company;
    if (!company) {
      localStorage.removeItem('company');
      return;
    } else {
      localStorage.setItem('company', JSON.stringify(state.company));
    }
  },
  setSettings(state, settings) {
    state.company.settings = settings;
  },
  setAdminCompany(state, { company, locations }) {
    state.company = company;
    state.locations = locations;
    state.locations.forEach((location) => {
      if (location.locationName !== 'Demo') {
        state.location = location;
        return;
      }
    });
  },
  setLocations(state, locations) {
    var defaultLocation = null;
    var testLocation = null;
    var newLocations = [];

    locations.forEach((location) => {
      if (location.name === 'Demo') {
        testLocation = location;
      } else if (location._id === state.user.defaultLocation) {
        defaultLocation = location;
      } else {
        newLocations.push(location);
      }
    });

    if (defaultLocation) {
      newLocations.unshift(defaultLocation);
    }
    if (testLocation) {
      newLocations.push(testLocation);
    }
    console.log(newLocations);
    state.locations = newLocations;
  },

  logout(state) {
    state.user = null;
    state.company = null;
    (state.loading = false), (state.expiryStatus = null);
    localStorage.removeItem('user');
    localStorage.removeItem('company');
  },
  changeLocation(state, location) {
    state.location = location;
  },
  setUsers(state, users) {
    state.users = users;
    state.loading = false;
  },
  newUser(state, item) {
    state.users.push(item);
    state.loading = false;
  },
  updateUser(state, item) {
    var index = state.users.findIndex((i) => {
      return i._id === item._id;
    });
    if (index !== -1) {
      state.users.splice(index, 1, item);
    }
    state.loading = false;
    if (state.user._id === item._id) {
      state.user = item;
      localStorage.setItem('user', JSON.stringify(state.user));
    }
  },
  deleteUser(state, id) {
    var index = state.users.findIndex((i) => {
      return i._id === id;
    });
    if (index !== -1) {
      state.users.splice(index, 1);
    }
    state.loading = false;
  },
  newLocation(state, item) {
    state.locations.push(item);
    state.loading = false;
  },
  updateLocation(state, item) {
    var index = state.locations.findIndex((i) => {
      return i._id === item._id;
    });
    if (index !== -1) {
      state.locations.splice(index, 1, item);
    }
    state.loading = false;
  },
  deleteLocation(state, id) {
    var index = state.locations.findIndex((i) => {
      return i._id === id;
    });
    if (index !== -1) {
      state.locations.splice(index, 1);
    }
    state.loading = false;
  },
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
};
